module.exports = __webpack_public_path__ + "media/LoopStart.3c047dae.webm";